slots.forEach(slot=>{
    slot.addEventListener('click', () => {
      if (isMobile()) return;
      const vid = slot.dataset.variantId;
      if (!vid) return;
      const cur = state.items[vid] || 0;
      // Context7: Defensive Programming - Validate before modifying
      if (cur <= 1) {
        delete state.items[vid];
      } else {
        state.items[vid] = cur - 1;
      }
      // Context7: Fail Fast - Validate total after modification
      const totalQty = Object.values(state.items).reduce((a,b)=>a+b,0);
      if (totalQty > maxSlots) {
        console.warn('[Bundle Builder] Slot click: Total quantity exceeds maximum, capping');
        state.items = capToMaximum(state.items, maxSlots);
      }
      markDirty(); 
      updateUI();
    });
  });

  function updateMilestoneChips(qOverride){
    if (!isMobile()) return;
    const sheetEl = document.getElementById('bb-sheet'); if (!sheetEl) return;
    const q = (typeof qOverride === 'number') ? qOverride : state.totalQty;
    const milestones = [0, ...tiers.map(t => t.qty)];
    const active = milestones.filter(m => q >= m).pop() ?? 0;
    sheetEl.querySelectorAll('.bb-milestones .bb-chip').forEach(chip=>{
      chip.classList.toggle('is-active', Number(chip.dataset.m) === active);
    });
  }

        /** Promise-basiertes Zuklappen mit sauberer Reihenfolge */
        function closeSheetAsync(){
            if (!sheetOpen || !sheet) return Promise.resolve();
    
            sheet.classList.remove('is-open');
            sheet.classList.add('is-closing');
            sheetOpen = false;
    
            return new Promise(resolve => {
              const finish = () => {
                sheet.setAttribute('hidden','');
                sheet.classList.remove('is-closing');
    
                // Schließen:
                  // kleines Timeout, dann aus dem Flow nehmen
                  setTimeout(()=> scrimGlobal?.setAttribute('hidden',''), 250);
                  unfreezeHeader();
                  unlockBodyScroll();
                  setSiblingsInert(false);
                  if (sheetPrevFocus && sheetPrevFocus.focus) sheetPrevFocus.focus();
                  sheetItems = null; // Draft verwerfen, wenn nicht committed
                  mobile_gateSticky();
                  bbTrack('sheet_close', { totalQty: Object.values(state.items || {}).reduce((a,b)=>a+b,0) });
    
                  document.documentElement.classList.remove('bb--sheet-open'); // <— NEU
    
                  resolve();
              };
    
              // robust gegen fehlende Events – Timeout als Fallback
              const t = setTimeout(finish, 500);
              panel?.addEventListener('animationend', () => { clearTimeout(t); finish(); }, { once:true });
            });
          }
    
          // Einfacher Fokus-Trap nur wenn Sheet offen ist
          const __bb_focusablesSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    
          function __bb_trapFocus(e){
            if (!sheetOpen) return;
            if (e.key !== 'Tab') return;
            const nodes = panel.querySelectorAll(__bb_focusablesSelector);
            if (!nodes.length) return;
            const first = nodes[0], last = nodes[nodes.length-1];
            if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
            else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
          }
          panel?.addEventListener('keydown', __bb_trapFocus);
    
          // Für Scrim-Klick, Close-Button & ESC:
          async function mobile_closeSheet(){ await closeSheetAsync(); }
    
        openBtn?.addEventListener('click', (e)=>{ if (!isMobile()) return; e.preventDefault(); mobile_openSheet(); });
        stickyEl?.querySelector('[data-bb-open]')?.addEventListener('click', (e)=>{ if (!isMobile()) return; e.preventDefault(); mobile_openSheet(); });
        
        // SSOT: Event-Delegation auf sheet-Ebene für Close/Reset/Commit (funktioniert auch nach DOM-Änderungen)
        // WICHTIG: Delegation auf sheet statt einzelne Buttons, damit es auch funktioniert wenn Buttons noch nicht existieren
        if (sheet) {
          // Verhindere mehrfache Anhängung
          if (!sheet.dataset.bbButtonsAttached) {
            sheet.dataset.bbButtonsAttached = 'true';
            sheet.addEventListener('click', (e)=>{
              // Close Button (unterstützt beide Varianten)
              const closeBtn = e.target.closest('[data-bb-close], [data-bb-close-global]');
              if (closeBtn) {
                e.preventDefault();
                e.stopPropagation();
                mobile_closeSheet();
                return;
              }
              
              // Reset Button (unterstützt beide Varianten)
              const resetBtn = e.target.closest('[data-bb-reset], [data-bb-reset-global]');
              if (resetBtn) {
                e.preventDefault();
                e.stopPropagation();
                sheetItems = {};                         // Draft leeren
                bbTrack('reset');
                mobile_updateSheetQuantities();
                mobile_updateSheetSummary();
                updateMilestoneChips(0);                 // Chips auf "0" setzen
                return;
              }
              
              // Commit Button (unterstützt beide Varianten)
              const commitBtn = e.target.closest('[data-bb-commit], [data-bb-commit-global]');
              if (commitBtn) {
                e.preventDefault();
                e.stopPropagation();
                handleCommit();
                return;
              }
            });
          }
        }
        
        // Globaler Scrim klickbar
        scrimGlobal?.addEventListener('click', (e)=>{ e.preventDefault(); mobile_closeSheet(); });
        document.addEventListener('keydown', (e)=>{ if (e.key === 'Escape' && sheetOpen) mobile_closeSheet(); });
    
        // === Recalc der Logo-Mitte bei Resize/Rotation, solange das Sheet offen ist ===
        function bbRecalcLogoCenterIfOpen(){
          if (!sheetOpen) return;
          const header =
            document.querySelector('sticky-header') ||
            document.querySelector('.header-wrapper') ||
            document.querySelector('header[role="banner"]') ||
            document.querySelector('header');
          const inner = header?.querySelector('.header') || header;
          const logo  = header?.querySelector('.header__heading img, .header__heading-logo, .site-header__logo-image, img[alt*="Logo"]');
          if (!inner || !logo) return;
          const hr = inner.getBoundingClientRect();
          const lr = logo.getBoundingClientRect();
          const cx = (lr.left - hr.left) + (lr.width / 2);
          document.documentElement.style.setProperty('--bb-logo-x', `${Math.round(cx)}px`);
        }
        window.addEventListener('resize', bbRecalcLogoCenterIfOpen, { passive: true });
        window.addEventListener('orientationchange', () => setTimeout(bbRecalcLogoCenterIfOpen, 200), { passive: true });
    
        // iOS/Android: VisualViewport ändert sich beim Öffnen von Overlays
        if (window.visualViewport) {
          const _vvRecalc = () => bbRecalcLogoCenterIfOpen();
          visualViewport.addEventListener('resize', _vvRecalc, { passive: true });
          visualViewport.addEventListener('scroll', _vvRecalc, { passive: true });
        }
    
        // Stepper Delegation - SSOT: Event-Delegation auf sheet-Ebene (funktioniert auch nach DOM-Änderungen)
        // WICHTIG: Delegation auf sheet statt panel, damit es auch nach Template-Ersetzung funktioniert
        if (sheet) {
          // Verhindere mehrfache Anhängung
          if (!sheet.dataset.bbStepperAttached) {
            sheet.dataset.bbStepperAttached = 'true';
            sheet.addEventListener('click', (e)=>{
              if (!isMobile() || !sheetOpen) return;
              
              // Add-Button Handler (öffnet Stepper)
              const addBtn = e.target.closest('.bb-btn-add');
              if (addBtn) {
                const tile = addBtn.closest('.bb-tile');
                if (tile) {
                  const plusBtn = tile.querySelector('[data-bb-plus]');
                  if (plusBtn) {
                    plusBtn.click();
                    return;
                  }
                }
              }
              
              // Plus/Minus Handler
              const plus  = e.target.closest('[data-bb-plus]');
              const minus = e.target.closest('[data-bb-minus]');
              if (!plus && !minus) return;
              const tile  = e.target.closest('.bb-tile'); 
              if (!tile) return;
              const vid   = String(tile.dataset.variantId);
  
              if (!sheetItems) sheetItems = JSON.parse(JSON.stringify(state.items || {}));
              const cur = sheetItems[vid] || 0;
              const draftTotal = Object.values(sheetItems).reduce((a,b)=>a+b,0);
  
              if (plus){
                if (draftTotal < maxSlots) sheetItems[vid] = cur + 1;
              } else {
                if (cur <= 1) delete sheetItems[vid];
                else sheetItems[vid] = cur - 1;
              }
  
              // Context7: Fail Fast - Validate immediately on change
              const totalSheetQty = Object.values(sheetItems).reduce((a,b)=>a+b,0);
              if (totalSheetQty > maxSlots) {
                console.warn('[Bundle Builder] Mobile stepper: Total quantity exceeds maximum, capping');
                sheetItems = capToMaximum(sheetItems, maxSlots);
              }
  
              // Nur Sheet-UI aktualisieren (Slots auf der PDP bleiben unverändert)
              mobile_updateSheetQuantities();
              mobile_updateSheetSummary();
              updateMilestoneChips(Object.values(sheetItems).reduce((a,b)=>a+b,0));
              bbTrack('qty_change', { variant_id: vid, delta: !!plus ? 1 : -1, qty: sheetItems[vid] || 0 });
            });
          }
        }
    
        // Commit Handler - SSOT: Event-Delegation auf sheet-Ebene
        // WICHTIG: Commit wird über die Event-Delegation oben (Zeile 2160) behandelt
        // Hier nur die Commit-Logik als separate Funktion für bessere Lesbarkeit
        async function handleCommit(){
          if (!isMobile()) return;
  
          const t0 = performance.now();
    
      // 0) Draft -> State übernehmen (Slots aktualisieren)
      if (sheetItems){
        // Context7: Defensive Programming - Validate before committing
        const totalSheetQty = Object.values(sheetItems).reduce((a,b)=>a+b,0);
        if (totalSheetQty > maxSlots) {
          console.warn('[Bundle Builder] Mobile commit: Total quantity exceeds maximum, capping to', maxSlots);
          const cappedSheetItems = capToMaximum(sheetItems, maxSlots);
          state.items = JSON.parse(JSON.stringify(cappedSheetItems));
        } else {
        state.items = JSON.parse(JSON.stringify(sheetItems));
        }
        markDirty();
        updateUI();
        bbTrack('commit', { totalQty: state.totalQty, tier_off: state.tier ? state.tier.off : 0 });
      }
    
      const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const wasOpenBefore = !!cartEl?.hasAttribute?.('open');
    
      // 1) Server-Sync starten (aber noch nicht awaiten)
      const syncP = syncCartBundleToState();
    
      // 2) Bottom-Sheet sauber schließen
      await closeSheetAsync();
    
      // 3) Jetzt sofort das Mobile-Overlay einblenden (Phase: "Zwischen Sheet und Drawer")
      bbMobileLoadingShow('Bundle wird erstellt …');
    
      // 4) Sanfte Mindestdauer gegen Flackern
      const MIN_MS = 350;
      const minP = bbDelay(MIN_MS);
    
      // 5) Auf Sync warten
      await syncP;
    
      // 6) Fast-Open: Drawer aufziehen, wenn gewünscht und schnell genug
      const elapsed = performance.now() - t0;
      if (openCartAfterAdd && elapsed <= FAST_OPEN_MS && !wasOpenBefore && !__bb_userClosedDuringSync) {
        cartEl?.open?.();
      }
    
          // 7) Overlay erst nach Mindestdauer wieder schließen (oder früher via Observer – siehe Patch 3)
          await minP;
          bbMobileLoadingHide();
        }
    
    
    
        // Express für BUNDLE: sync -> Checkout (zeigt Wallet-Optionen oben)
        document.querySelector('[data-bb-express-bundle]')?.addEventListener('click', async (e)=>{
          e.preventDefault();
    
          // 1) Wenn das Bottom-Sheet offen ist: aktuellen Draft übernehmen (wie bei Commit)
          if (typeof sheetItems !== 'undefined' && sheetItems) {
            state.items = JSON.parse(JSON.stringify(sheetItems));
            markDirty();
            updateUI();
          }
    
          // 2) Server syncen (deine bestehende Funktion)
          await syncCartBundleToState();
    
          // 3) Direkt zur Checkout-Seite (Shopify zeigt dort Express/Wallet oben)
          window.location.assign('/checkout');
        });
    
        // Sheet-Summary + Tile-Qty - Unterstützt beide Varianten (mit/ohne -global)
        const $sheetSummary = sheet?.querySelector('[data-bb-sheet-summary]');
        const $sheetCount = sheet?.querySelector('[data-bb-sheet-count], [data-bb-sheet-count-global]');
        const $sheetNext  = sheet?.querySelector('[data-bb-sheet-next], [data-bb-sheet-next-global]');
        function mobile_updateSheetSummary(){
          if (!isMobile()) return;
          const src = sheetItems || state.items;
          const q = Object.values(src).reduce((a,b)=>a+b,0);
          if ($sheetCount) $sheetCount.textContent = `${q}/${maxSlots}`;
          const next = tiers.find(t => t.qty > q);
          if ($sheetNext){
            if (!q && next){ $sheetNext.textContent = `noch ${next.qty - q} bis −${next.off}%`; }
            else if (next){ $sheetNext.textContent = `noch ${next.qty - q} bis −${next.off}%`; }
            else { $sheetNext.textContent = `max. Vorteil erreicht`; }
          }
        }
        function mobile_updateSheetQuantities(){
          if (!isMobile()) return;
          const src = sheetItems || state.items;
          sheet?.querySelectorAll('.bb-tile').forEach(tile=>{
            const vid = String(tile.dataset.variantId);
            const qty = src[vid] || 0;
            
            // Update data-qty attribute
            tile.setAttribute('data-qty', String(qty));
            
            const qtyEl = tile.querySelector('[data-bb-qty]');
            const addBtn = tile.querySelector('.bb-btn-add');
            const stepper = tile.querySelector('.bb-stepper');
            
            if (qty === 0) {
              // Initial-Zustand: Keine "0" anzeigen, nur Add-Button sichtbar
              if (qtyEl) qtyEl.textContent = '';
              if (addBtn) {
                addBtn.style.display = '';
                addBtn.removeAttribute('hidden');
              }
              if (stepper) {
                stepper.style.display = 'none';
                stepper.setAttribute('hidden', '');
              }
            } else {
              // qty > 0: Menge anzeigen, Stepper sichtbar, Add-Button versteckt
              if (qtyEl) qtyEl.textContent = String(qty);
              if (addBtn) {
                addBtn.style.display = 'none';
                addBtn.setAttribute('hidden', '');
              }
              if (stepper) {
                stepper.style.display = 'flex';
                stepper.removeAttribute('hidden');
              }
            }
          });
        }
        // Slot-Labels für Mobile (−off% auf Tier-Slots, sonst 1..10)
        function mobile_applySlotNumbers(){
          if (!isMobile()) return;
          document.querySelectorAll('.bb__slot').forEach((slot, i)=>{
            const idx = i + 1;
            const label = slot.querySelector('[data-bb-label]');
            if (!label) return;
            label.textContent = getSlotLabelText(idx); // nutzt den neuen Helper
          });
        }
    
        // Aria im Slot straffen
        function mobile_fixSlotAria(){
          if (!isMobile()) return;
          document.querySelectorAll('.bb__slot').forEach(slot=>{
            const i = slot.dataset.slot;
            slot.setAttribute('aria-label', `Slot ${i}`);
          });
        }
    
    // Initialisierung Mobile
        if (isMobile()){
          mobile_buildTicks();
          mobile_applySlotNumbers();
          mobile_updateSticky();
          mobile_gateSticky();
          mobile_fixSlotAria();
    
          // === NEU: GLOBALER EVENT LISTENER (The Remote Control) ===
          // Erlaubt anderen Sections (z.B. Featured Collection), das Sheet zu öffnen
          document.addEventListener('edm:activate-bundle', (e) => {
            // Optional: Prüfen, ob die angeforderte Variante passt (Future Proofing)
            // const requestedVariantId = e.detail?.variantId;
            
            if (!sheetOpen) {
              mobile_openSheet();
            } else {
              // Falls schon offen: Fokus oder kurzer Shake-Effekt
              const panel = document.querySelector('.bb-sheet__panel');
              if(panel) {
                panel.classList.add('bb--pulse'); 
                setTimeout(() => panel.classList.remove('bb--pulse'), 300);
              }
            }
          });
    
          // === AUTO-OPEN LOGIC (Fallback für PDP Redirects) ===
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('trigger_sheet') === 'true') {
            setTimeout(() => {
              if (!sheetOpen) {
                mobile_openSheet();
                try {
                  const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                  window.history.replaceState({path: newUrl}, '', newUrl);
                } catch(e) {}
              }
            }, 300); 
          }
        }
    